import React from 'react';
import { Box, Button, Paper, Table, TableContainer, Typography } from '@mui/material';
import { HiOutlineArrowNarrowLeft } from 'react-icons/hi';
import { useParams, useHistory } from 'react-router-dom';

import Adjustment from '../../shared/modals/adjustment';
import useInvoicingHistory from './useInvoicingHistory';
import useStyles from './styles';
import { DashboardBody, DashboardHeader } from '../../shared';
import RenderIf from '../../renderIf';

const InvoicingHistory = ({ location }) => {
    const { uniqueId, termId } = useParams();
    const history = useHistory();
    const styles = useStyles();

    const {
        isInitialized,
        doingAjax,
        scholarshipInfoHeaders,
        scholarshipData,
        tuitionInformation,
        invoicesList,
        invoicesHeaders,
        isAdjustmentOpen,
        adjustmentData,
        studentName,
        retrieveFinancialData,
        toggleAdjustmentWindow,
    } = useInvoicingHistory(uniqueId, termId);

    React.useEffect(() => {
        retrieveFinancialData();
    }, []);

    const handleBack = () => {
        history.push(location.state.backPathName, {
            tabConfig: {
                defaultView: 'invoices',
            },
            listState: location?.state?.listState,
        });
    };

    return (
        <Box className={styles.pageContainer}>
            <Button onClick={() => handleBack()}>
                <HiOutlineArrowNarrowLeft /> Back to invoices
            </Button>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    marginBottom: (theme) => theme.spacing(2),
                }}
            >
                <Typography className={styles.title}>
                    <RenderIf isTrue={isInitialized}>
                        <Box
                            component="span"
                            className={styles.blue}
                        >
                            {studentName}'s
                        </Box>{' '}
                        Financial Data
                    </RenderIf>

                    <RenderIf isTrue={!isInitialized}>
                        <Box
                            component="span"
                            className={styles.blue}
                        >
                            Retrieving
                        </Box>{' '}
                        Financial Data...
                    </RenderIf>
                </Typography>
            </Box>

            <RenderIf isTrue={isInitialized}>
                {isAdjustmentOpen ? (
                    <Adjustment
                        tuitionData={adjustmentData}
                        onClose={toggleAdjustmentWindow}
                    />
                ) : null}

                <Paper className={styles.paper}>
                    <Box className={styles.section}>
                        <Typography className={styles.sectionTitle}>Scholarship Information</Typography>

                        <TableContainer>
                            <Table>
                                <DashboardHeader headers={scholarshipInfoHeaders} />

                                <DashboardBody
                                    list={scholarshipData}
                                    headers={scholarshipInfoHeaders}
                                    disabled={doingAjax}
                                />
                            </Table>
                        </TableContainer>
                    </Box>

                    {tuitionInformation?.length > 0
                        ? tuitionInformation.map((school) => {
                              let SchoolName = () => (
                                  <Box
                                      component="span"
                                      className={styles?.schoolName}
                                  >
                                      ({school.schoolName})
                                  </Box>
                              );
                              return (
                                  <Box className={styles.section}>
                                      <Typography className={styles.sectionTitle}>
                                          Tuition Information <SchoolName />
                                      </Typography>

                                      <TableContainer>
                                          <Table>
                                              <DashboardHeader headers={school?.headers || []} />

                                              <DashboardBody
                                                  list={school?.list || []}
                                                  headers={school?.headers || []}
                                                  handleNav={toggleAdjustmentWindow}
                                                  disabled={doingAjax}
                                              />
                                          </Table>
                                      </TableContainer>
                                  </Box>
                              );
                          })
                        : null}

                    <Box className={styles.section}>
                        <Typography className={styles.sectionTitle}>Invoices</Typography>

                        <TableContainer>
                            <Table>
                                <DashboardHeader headers={invoicesHeaders} />

                                <DashboardBody
                                    list={invoicesList}
                                    headers={invoicesHeaders}
                                    disabled={doingAjax}
                                />
                            </Table>
                        </TableContainer>
                    </Box>
                </Paper>
            </RenderIf>
        </Box>
    );
};

export default InvoicingHistory;
